/* eslint-disable import/prefer-default-export */

export const futureFormSubmitted = () => (
  { type: 'FUTURE_FORM_SUBMITTED' }
)


// WEBPACK FOOTER //
// ./src/actions/futureFormActionCreators.js